import { useEffect, useState } from "react";

import { Box, Grid, Switch, TextField, Typography } from "@mui/material";

import { DrawerForm, DrawerFormSection } from "../../../../components/DrawerForm";
import { FormHiddenField } from "../../../../components/forms";
import { DRAWER_FORM_GRID_SPACING, drawerReadonlyFieldSx } from "../../../../lib/ui/dialogFormLayout";
import { useTranslation } from "react-i18next";

const EditMailFilterDialogBody = (item: any) => {
  const { t } = useTranslation();
  const [status, setStatus] = useState(true);

  useEffect(() => {
    const next = item?.status === true || String(item?.status) === "true";
    setStatus(next);
  }, [item]);

  return (
    <DrawerForm>
      <DrawerFormSection title={t("form.filter")}>
        <Grid container spacing={DRAWER_FORM_GRID_SPACING}>
          <Grid size={12}>
            <TextField
              fullWidth
              id="id"
              name="id"
              label={t("common.id")}
              variant="outlined"
              size="small"
              value={item?.id || ""}
              InputProps={{ readOnly: true }}
              sx={drawerReadonlyFieldSx}
            />
          </Grid>
          <Grid size={12}>
            <TextField
              required
              fullWidth
              id="name"
              name="name"
              label={t("common.name")}
              variant="outlined"
              size="small"
              defaultValue={item?.name || ""}
            />
          </Grid>
          <Grid size={12}>
            <TextField
              fullWidth
              id="description"
              name="description"
              label={t("common.description")}
              variant="outlined"
              size="small"
              defaultValue={item?.description || ""}
            />
          </Grid>
          <Grid size={12}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1, minHeight: 40 }}>
              <Switch size="small" checked={status} onChange={(e) => setStatus(e.target.checked)} />
              <Typography variant="body2">{status ? "Active" : "Inactive"}</Typography>
              <FormHiddenField name="status" value={status ? "true" : "false"} />
            </Box>
          </Grid>
        </Grid>
      </DrawerFormSection>

      <DrawerFormSection title={t("form.match")}>
        <Grid container spacing={DRAWER_FORM_GRID_SPACING}>
          <Grid size={12}>
            <TextField
              required
              fullWidth
              id="subject"
              name="subject"
              label={t("mailFilters.subject")}
              variant="outlined"
              size="small"
              defaultValue={item?.subject || ""}
            />
          </Grid>
          <Grid size={12}>
            <TextField
              required
              fullWidth
              id="body"
              name="body"
              label={t("mailFilters.body")}
              multiline
              rows={5}
              variant="outlined"
              size="small"
              defaultValue={item?.body || ""}
            />
          </Grid>
        </Grid>
      </DrawerFormSection>
    </DrawerForm>
  );
};

export default EditMailFilterDialogBody;
